import React from "react";
import reportWebVitals from "./reportWebVitals";
import * as ReactDOM from "react-dom/client";
import { ThemeContextProvider, getVivoSkin } from "@telefonica/mistica";
import "@telefonica/mistica/css/mistica.css";
import { router } from "./routes";
import { RouterProvider } from "react-router";
import "./App.scss";
import { GlobalStoreProvider } from "./contexts/globalStoreContext";
import { Fonts } from "./theme/Fonts";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
	<React.StrictMode>
		<Fonts />
		<GlobalStoreProvider>
			<ThemeContextProvider
				theme={{
					skin: getVivoSkin(),
					i18n: { locale: "pt-BR", phoneNumberFormattingRegionCode: "ES" },
					colorScheme: "light",
				}}
			>
				<RouterProvider router={router} />
			</ThemeContextProvider>
		</GlobalStoreProvider>
	</React.StrictMode>,
);

reportWebVitals();
